// ---------------------------------------------------------------------------
// DESIGN TOKENS JS: Best Practice Guidance
// ---------------------------------------------------------------------------
// - This file should be auto-generated from the SCSS palette or a single source of truth (JSON/TS/SCSS).
// - Do NOT hand-edit color literals; keep in sync with SCSS (_colors.scss) and CSS vars.
// - TODO: Add a build step to automate this sync (e.g., using Style Dictionary or a custom script).
// ---------------------------------------------------------------------------
// Centralized JS design tokens to keep Vuetify theme in sync with SCSS palette.
// SCSS remains the source for compiled styles; this JS map allows runtime/theme
// configuration without duplicating literals scattered across the codebase.
// ---------------------------------------------------------------------------

/**
 * Base color palette matching SCSS $color-palette map in _colors.scss
 * Keep in sync with SCSS definitions
 */
export const palette = {
  // Primary Brand Colors
  primary: '#193541',
  primaryAlt: '#668499', // --primary-300
  secondary: '#274856', // --color-secondary-base
  accent: '#8DC7A8', // --green-400
  
  // Status Colors
  success: '#37AE78', // --green-500
  warning: '#EBA937', // --amber-default
  info: '#4285F4', // --blue-500
  error: '#B22222', // --red-flag
  
  // Extended Brand Colors
  indigo: '#3162B4', // --blue-800
  teal: '#298159', // --green-800
  
  // App-specific Brand Colors (accounting === primary)
  accounting: '#193541',
  compliance: '#E85B61', // --red-500
  risk: '#34A672', // --green-600
  transaction: '#4285F4', // --blue-500
  
  // Surface Colors
  surfacePurple: '#F3F6FE', // --blue-50
  background: '#F7F7F7', // --grey-50
  
  // Border Colors
  purpleBorder: '#E8EEFD', // --blue-100
  purpleBorderOnly: '#CFDDFB', // --blue-200
  tableHeaderBorder: '#CBCBCC', // --grey-200
  
  // Navigation Colors
  navBg: '#193541', // --color-bg-nav
  menuHoverBg: '#E5E5E5', // --grey-100
  
  // Hover/Active States
  blueHover: '#CFDDFB', // --blue-200
  
  // Grayscale
  gray700: '#55555B', // --grey-700
  gray600: '#6B6B6F', // --grey-600
  gray500: '#828285', // --grey-500
  gray550: '#828285', // --grey-500
  gray050: '#F7F7F7', // --grey-50
  
  // Semantic Soft Colors
  yellow700: '#A98307', // --yellow-700
  yellowSoft: '#FAF7F2', // --yellow-50
  orange700: '#A98307', // --yellow-700 (fallback)
  orangeSoft: '#FAF7F2', // --yellow-50 (fallback)
  greenAccent: '#37AE78', // --green-500
  greenSoft: '#F3F8F5', // --green-50
  greenSoft2: '#F3F8F5', // --green-50
  redSoft1: '#FDF4F4', // --red-50
  redSoft2: '#FDF4F4', // --red-50
  accountingSoft: '#F3F6FE', // --blue-50
  editProfile: '#E5E5E5' // --grey-100
};

export const vuetifyThemeLight = {
  primary: palette.primary,
  fbcPrimary: palette.primaryAlt,
  secondary: palette.secondary,
  accent: palette.accent,
  success: palette.success,
  warning: palette.warning,
  info: palette.info,
  error: palette.error,
  indigo: palette.indigo,
  teal: palette.teal,
  caccounting: palette.accounting,
  ccompliance: palette.compliance,
  crisk: palette.risk,
  ctransaction: palette.transaction,
  lightpurple: palette.surfacePurple,
  purpleborderonly: palette.purpleBorderOnly,
  tableheaderborder: palette.tableHeaderBorder,
  purple: palette.primary,
  lightgrey: palette.gray600,
  darkgray: palette.gray700,
  gray: palette.gray500,
  gray550: palette.gray550,
  background: palette.background,
  yellow: palette.yellow700,
  orange: palette.orange700,
  green: palette.greenAccent,
  lightred: palette.redSoft1,
  lightred2: palette.redSoft2,
  lightgreen2: palette.greenSoft2,
  lightCaccounting: palette.accountingSoft,
  lightorange: palette.orangeSoft,
  btnColor: palette.primaryAlt,
  lightblue: palette.blueHover,
  lightgray: palette.gray050,
  lightyellow: palette.yellowSoft,
  lightgreen: palette.greenSoft,
  editProfile: palette.editProfile
};

/**
 * Convenience export merging palette + theme keys (non-conflicting) for runtime usage
 * Use this when you need access to all tokens in a single object
 */
export const tokens = { ...palette, ...vuetifyThemeLight };

/**
 * Default export for backward compatibility
 */
export default {
  palette,
  vuetifyThemeLight,
  tokens
};
